import { styled, Text } from '@obvio/app'
import { Section } from '@obvio/ui'

import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

const CenteredSection = styled(Section)`
  text-align: center;
  margin-top: ${(theme) => theme.spacing.big};
`

const Name = styled(Text)`
  margin-bottom: 25vh;
`

type ArtistNameProps = {
  name: string
}

export function ArtistName({ name }: ArtistNameProps): ReactElement {
  return (
    <FadeIn>
      <CenteredSection>
        <Name tag="h1" as="h3">
          {name}
        </Name>
      </CenteredSection>
    </FadeIn>
  )
}
